import { lazy, Suspense } from "react"

import { FallbackCardDashboard } from "@/pages/DashboardPage/components/organisms/FallbackCardDashboard"

import type { RemediationActivityWidgetProps } from "."

const RemediationActivityWidgetComponent = lazy(() =>
  import("./RemediationActivityWidgetComponent").catch(() => ({
    default: () => (
      <FallbackCardDashboard
        title="Remediation Activity"
        subTitle="Last 30 days"
      />
    )
  }))
)

export const RemediationActivityWidget = (
  props: RemediationActivityWidgetProps
) => {
  const { isLoading: _, ...rest } = props

  return (
    <Suspense fallback={<FallbackCardDashboard {...rest} />}>
      <RemediationActivityWidgetComponent {...props} />
    </Suspense>
  )
}
